module.exports = __webpack_public_path__ + "img/wheel-min.60629c38.png";